import { IColumnDefinition } from 'features/Lists/core/contracts/IColumnDefinition'

export enum BreakSummaryStatusEnum {
  InProgress = 'InProgress',
  New = 'New',
  Suppressed = 'Suppressed',
  PermanentlySuppressed = 'PermanentlySuppressed',
  Resolved = 'Resolved'
}

enum ColumnIdsEnum {
  id = 'id',
  legalEntityName = 'legalEntityName',
  accountNo = 'accountNo',
  securityDesc = 'securityDesc',
  cusip = 'cusip',
  breakSummaryDetails = 'breakSummaryDetails',
  breakStatus = 'breakStatus',
  breakDesc = 'breakDesc',
  breakdetailcount = 'breakdetailcount',
  drawdown = 'drawdown',
  assignedTo = 'assignedTo',
  committedCapital = 'committedCapital',
  capitalCalled = 'capitalCalled',
  remainingCapital = 'remainingCapital',
  distributionIncome = 'distributionIncome',
  netInvAmount = 'netInvAmount',
  totalIncomeReinv = 'totalIncomeReinv',
  lastValuationValue = 'lastValuationValue',
  valuationDate = 'valuationDate',
  valuationReceivedDate = 'valuationReceivedDate',
  reconDate = 'reconDate',
  reconAge = 'reconAge',
  adjMarketValue = 'adjMarketValue',
  adjTotalValue = 'adjTotalValue',
  price = 'price',
  quantity = 'quantity',
  adjTVPI = 'adjTVPI',
  annualizedIRR = 'annualizedIRR',
  comments = 'comments',
  breakSummaryId = 'breakSummaryId',
  breakSummaryStatus = 'breakSummaryStatus',
  assignBreak = 'assignBreak',
  updatedBy = 'updatedBy',
  updatedDate = 'updatedDate',
  accountId = 'accountId',
  fundbreakcount = 'fundbreakcount',
  advisorName = 'advisorName',
  householdName = 'householdName',
  lasttransactionType = 'lasttransactionType',
  lasttransactionAmount = 'lasttransactionAmount',
  lasttransactionDate = 'lasttransactionDate',
  l1Description = 'l1Description',
  l2Description = 'l2Description',
  l3Description = 'l3Description',
  l4Description = 'l4Description',
  assetType = 'assetType',
  assetSubType = 'assetSubType',
  dataSource = 'dataSource',
  transType = 'transType',
  platform = 'platform',
  fundStructure = 'fundStructure'
}

export const ReconDataSummaryColumnIds = { ...ColumnIdsEnum }
export type ReconDataSummaryColumnIds = typeof ReconDataSummaryColumnIds

export const ReconDataSummaryColumnDefinitions: Record<
  string,
  IColumnDefinition
> = {
  [ReconDataSummaryColumnIds.id]: {
    id: ReconDataSummaryColumnIds.id,
    name: ' ',
    type: 'string',
    width: 30,
    filterable: false,
    sortable: false,
    searchable: false,
    facetable: false,
    dataPath: 'id',
    selectable: false
  },
  [ReconDataSummaryColumnIds.legalEntityName]: {
    id: ReconDataSummaryColumnIds.legalEntityName,
    name: 'Legal entity name',
    type: 'string',
    width: 180,
    filterable: true,
    sortable: true,
    searchable: true,
    facetable: false,
    dataPath: 'legalEntityName',
    selectable: false
  },
  [ReconDataSummaryColumnIds.accountNo]: {
    id: ReconDataSummaryColumnIds.accountNo,
    name: 'Account number',
    type: 'string',
    width: 150,
    filterable: true,
    sortable: true,
    searchable: true,
    facetable: false,
    dataPath: 'accountNo',
    selectable: false
  },
  [ReconDataSummaryColumnIds.securityDesc]: {
    id: ReconDataSummaryColumnIds.securityDesc,
    name: 'Description',
    type: 'string',
    width: 280,
    filterable: true,
    sortable: true,
    searchable: true,
    facetable: true,
    dataPath: 'securityDesc',
    selectable: false
  },
  [ReconDataSummaryColumnIds.cusip]: {
    id: ReconDataSummaryColumnIds.cusip,
    name: 'CUSIP',
    type: 'string',
    width: 120,
    filterable: true,
    sortable: true,
    searchable: true,
    facetable: false,
    dataPath: 'cusip',
    selectable: false
  },
  [ReconDataSummaryColumnIds.breakSummaryDetails]: {
    id: ReconDataSummaryColumnIds.breakSummaryDetails,
    name: 'Action',
    type: 'string',
    width: 180,
    filterable: false,
    sortable: false,
    searchable: false,
    facetable: false,
    dataPath: 'breakSummaryDetails',
    selectable: false
  },
  //Virtual column for filtering on nested breakSummaryDetails collection's breakStatus
  [ReconDataSummaryColumnIds.breakStatus]: {
    id: ReconDataSummaryColumnIds.breakStatus,
    name: 'Break Status',
    type: 'string',
    width: 1,
    filterable: true,
    sortable: false,
    searchable: false,
    facetable: true,
    dataPath: 'breakStatus',
    collectionPath: 'breakSummaryDetails',
    hidden: true
  },
  [ReconDataSummaryColumnIds.householdName]: {
    id: ReconDataSummaryColumnIds.householdName,
    name: 'Household Name',
    type: 'string',
    width: 200,
    filterable: true,
    sortable: true,
    searchable: true,
    facetable: false,
    dataPath: 'householdName'
  },
  [ReconDataSummaryColumnIds.advisorName]: {
    id: ReconDataSummaryColumnIds.advisorName,
    name: 'Advisor Name',
    type: 'string',
    width: 200,
    filterable: true,
    sortable: true,
    searchable: true,
    facetable: false,
    dataPath: 'advisorName'
  },
  [ReconDataSummaryColumnIds.breakDesc]: {
    id: ReconDataSummaryColumnIds.breakDesc,
    name: 'Break description',
    type: 'string',
    width: 160,
    filterable: true,
    sortable: true,
    searchable: true,
    facetable: true,
    dataPath: 'breakDetailDescription',
    collectionPath: 'breakSummaryDetails',
    sortDataPath: 'breakDesc',
    select: ['breakDesc']
  },
  [ReconDataSummaryColumnIds.breakdetailcount]: {
    id: ReconDataSummaryColumnIds.breakdetailcount,
    name: 'No of breaks',
    type: 'number',
    width: 120,
    filterable: false,
    sortable: true,
    searchable: false,
    facetable: false,
    dataPath: 'breakdetailcount'
  },
  [ReconDataSummaryColumnIds.drawdown]: {
    id: ReconDataSummaryColumnIds.drawdown,
    name: 'Drawdown',
    type: 'string',
    width: 110,
    filterable: true,
    sortable: true,
    searchable: true,
    facetable: true,
    dataPath: 'drawdown'
  },
  [ReconDataSummaryColumnIds.fundStructure]: {
    id: ReconDataSummaryColumnIds.fundStructure,
    name: 'Fund Structure',
    type: 'string',
    width: 160,
    filterable: true,
    sortable: true,
    searchable: true,
    facetable: true,
    dataPath: 'fundStructure'
  },
  [ReconDataSummaryColumnIds.assignedTo]: {
    id: ReconDataSummaryColumnIds.assignedTo,
    name: 'Assigned to',
    type: 'string',
    width: 120,
    filterable: true,
    sortable: true,
    searchable: true,
    facetable: true,
    dataPath: 'assignedTo'
  },
  [ReconDataSummaryColumnIds.committedCapital]: {
    id: ReconDataSummaryColumnIds.committedCapital,
    name: 'Committed capital/ total subscription',
    type: 'number',
    width: 200,
    filterable: true,
    sortable: true,
    searchable: false,
    facetable: false,
    dataPath: 'committedCapital',
    className: 'reconDataWarningTooltipWrapper'
  },
  [ReconDataSummaryColumnIds.capitalCalled]: {
    id: ReconDataSummaryColumnIds.capitalCalled,
    name: 'Capital called',
    type: 'number',
    width: 125,
    filterable: true,
    sortable: true,
    searchable: false,
    facetable: false,
    dataPath: 'capitalCalled',
    className: 'reconDataWarningTooltipWrapper'
  },
  [ReconDataSummaryColumnIds.remainingCapital]: {
    id: ReconDataSummaryColumnIds.remainingCapital,
    name: 'Remaining capital',
    type: 'number',
    width: 160,
    filterable: true,
    sortable: true,
    searchable: false,
    facetable: false,
    dataPath: 'remainingCapital',
    className: 'reconDataWarningTooltipWrapper'
  },
  [ReconDataSummaryColumnIds.distributionIncome]: {
    id: ReconDataSummaryColumnIds.distributionIncome,
    name: 'Distributions to date / income',
    type: 'number',
    width: 200,
    filterable: true,
    sortable: true,
    searchable: false,
    facetable: false,
    dataPath: 'distributionIncome',
    className: 'reconDataWarningTooltipWrapper'
  },
  [ReconDataSummaryColumnIds.netInvAmount]: {
    id: ReconDataSummaryColumnIds.netInvAmount,
    name: 'Net Investment Amount',
    type: 'number',
    width: 150,
    filterable: true,
    sortable: true,
    searchable: false,
    facetable: false,
    dataPath: 'netInvAmount',
    className: 'reconDataWarningTooltipWrapper'
  },
  [ReconDataSummaryColumnIds.totalIncomeReinv]: {
    id: ReconDataSummaryColumnIds.totalIncomeReinv,
    name: 'Total Income Reinvested',
    type: 'number',
    width: 150,
    filterable: true,
    sortable: true,
    searchable: false,
    facetable: false,
    dataPath: 'totalIncomeReinv',
    className: 'reconDataWarningTooltipWrapper'
  },
  [ReconDataSummaryColumnIds.lastValuationValue]: {
    id: ReconDataSummaryColumnIds.lastValuationValue,
    name: 'Last Valuation Value',
    type: 'number',
    width: 150,
    filterable: true,
    sortable: true,
    searchable: false,
    facetable: false,
    dataPath: 'lastValuationValue',
    className: 'reconDataWarningTooltipWrapper'
  },
  [ReconDataSummaryColumnIds.valuationDate]: {
    id: ReconDataSummaryColumnIds.valuationDate,
    name: 'Valuation Date',
    type: 'string',
    width: 180,
    filterable: true,
    sortable: true,
    searchable: true,
    facetable: false,
    dataPath: 'valuationDate',
    className: 'reconSummaryDateFormat'
  },
  [ReconDataSummaryColumnIds.valuationReceivedDate]: {
    id: ReconDataSummaryColumnIds.valuationReceivedDate,
    name: 'Valuation Received Date',
    type: 'string',
    width: 200,
    filterable: true,
    sortable: true,
    searchable: true,
    facetable: false,
    dataPath: 'valuationReceivedDate',
    className: 'reconSummaryDateFormat'
  },
  [ReconDataSummaryColumnIds.reconDate]: {
    id: ReconDataSummaryColumnIds.reconDate,
    name: 'Recon Date',
    type: 'date-only',
    width: 100,
    filterable: true,
    sortable: true,
    searchable: false,
    facetable: false,
    dataPath: 'reconDate',
    className: 'reconSummaryDateFormat'
  },
  [ReconDataSummaryColumnIds.reconAge]: {
    id: ReconDataSummaryColumnIds.reconAge,
    name: 'Recon Age',
    type: 'number',
    width: 100,
    filterable: false,
    sortable: true,
    searchable: false,
    facetable: false,
    dataPath: 'reconAge'
  },
  [ReconDataSummaryColumnIds.adjMarketValue]: {
    id: ReconDataSummaryColumnIds.adjMarketValue,
    name: 'Adjusted Market Value',
    type: 'number',
    width: 160,
    filterable: true,
    sortable: true,
    searchable: false,
    facetable: false,
    dataPath: 'adjMarketValue',
    className: 'reconDataWarningTooltipWrapper'
  },
  [ReconDataSummaryColumnIds.adjTotalValue]: {
    id: ReconDataSummaryColumnIds.adjTotalValue,
    name: 'Adjusted Total Value',
    type: 'number',
    width: 180,
    filterable: true,
    sortable: true,
    searchable: false,
    facetable: false,
    dataPath: 'adjTotalValue',
    className: 'reconDataWarningTooltipWrapper'
  },
  [ReconDataSummaryColumnIds.price]: {
    id: ReconDataSummaryColumnIds.price,
    name: 'Price',
    type: 'number',
    width: 120,
    filterable: true,
    sortable: true,
    searchable: false,
    facetable: false,
    dataPath: 'price',
    className: 'reconDataWarningTooltipWrapper'
  },
  [ReconDataSummaryColumnIds.quantity]: {
    id: ReconDataSummaryColumnIds.quantity,
    name: 'Quantity',
    type: 'number',
    width: 120,
    filterable: true,
    sortable: true,
    searchable: false,
    facetable: false,
    dataPath: 'quantity',
    className: 'reconDataWarningTooltipWrapper'
  },
  [ReconDataSummaryColumnIds.adjTVPI]: {
    id: ReconDataSummaryColumnIds.adjTVPI,
    name: 'Adjusted TVPI',
    type: 'number',
    width: 160,
    className: 'reconDataWarningTooltipWrapper',
    filterable: true,
    sortable: true,
    searchable: false,
    facetable: false,
    dataPath: 'adjTVPI'
  },
  [ReconDataSummaryColumnIds.annualizedIRR]: {
    id: ReconDataSummaryColumnIds.annualizedIRR,
    name: 'Annualized IRR',
    type: 'number',
    width: 180,
    filterable: true,
    sortable: true,
    searchable: false,
    facetable: false,
    dataPath: 'annualizedIRR',
    className: 'reconDataWarningTooltipWrapper'
  },
  [ReconDataSummaryColumnIds.lasttransactionType]: {
    id: ReconDataSummaryColumnIds.lasttransactionType,
    name: 'Last Transaction Type',
    type: 'string',
    width: 145,
    filterable: true,
    sortable: true,
    searchable: false,
    facetable: false,
    dataPath: 'lasttransactionType'
  },
  [ReconDataSummaryColumnIds.lasttransactionAmount]: {
    id: ReconDataSummaryColumnIds.lasttransactionAmount,
    name: 'Last Transaction Value',
    type: 'number',
    width: 180,
    filterable: true,
    sortable: true,
    searchable: false,
    facetable: false,
    dataPath: 'lasttransactionAmount',
    className: 'reconDataWarningTooltipWrapper'
  },
  [ReconDataSummaryColumnIds.lasttransactionDate]: {
    id: ReconDataSummaryColumnIds.lasttransactionDate,
    name: 'Last Transaction Date',
    type: 'date-only',
    width: 145,
    filterable: true,
    sortable: true,
    searchable: false,
    facetable: false,
    dataPath: 'lasttransactionDate',
    className: 'reconSummaryDateFormat'
  },
  [ReconDataSummaryColumnIds.comments]: {
    id: ReconDataSummaryColumnIds.comments,
    name: 'Comments',
    type: 'string',
    width: 110,
    filterable: true,
    sortable: true,
    searchable: false,
    facetable: false,
    dataPath: 'comments'
  },
  [ReconDataSummaryColumnIds.breakSummaryStatus]: {
    id: ReconDataSummaryColumnIds.breakSummaryStatus,
    name: 'Break Summary Status',
    type: 'string',
    width: 130,
    filterable: true,
    sortable: true,
    searchable: false,
    facetable: true,
    dataPath: 'breakSummaryStatus',
    validFacetValues: [
      BreakSummaryStatusEnum.InProgress,
      BreakSummaryStatusEnum.New,
      BreakSummaryStatusEnum.Suppressed,
      BreakSummaryStatusEnum.PermanentlySuppressed
    ]
  },
  [ReconDataSummaryColumnIds.dataSource]: {
    id: ReconDataSummaryColumnIds.dataSource,
    name: 'Data Source',
    type: 'string',
    width: 120,
    filterable: true,
    sortable: true,
    searchable: true,
    facetable: true,
    dataPath: 'dataSource'
  },
  [ReconDataSummaryColumnIds.transType]: {
    id: ReconDataSummaryColumnIds.transType,
    name: 'Transfer Type',
    type: 'string',
    width: 180,
    filterable: true,
    sortable: true,
    searchable: true,
    facetable: true,
    dataPath: 'TransType'
  },
  // Hidden helper column used for "Assigned To Me" filtering logic
  [ReconDataSummaryColumnIds.assignBreak]: {
    id: ReconDataSummaryColumnIds.assignBreak,
    name: 'Assigned Break',
    type: 'string',
    width: 1,
    filterable: true,
    sortable: true,
    searchable: true,
    facetable: true,
    hidden: true,
    dataPath: 'assignBreak'
  },
  [ReconDataSummaryColumnIds.accountId]: {
    id: ReconDataSummaryColumnIds.accountId,
    name: ' ',
    type: 'string',
    width: 30,
    filterable: false,
    sortable: false,
    searchable: false,
    facetable: false,
    dataPath: 'accountId',
    selectable: false,
    hidden: true,
    className: 'accountIdColumn'
  },
  [ReconDataSummaryColumnIds.l1Description]: {
    id: ReconDataSummaryColumnIds.l1Description,
    name: 'L1 Description',
    type: 'string',
    width: 1,
    filterable: false,
    sortable: false,
    searchable: false,
    facetable: false,
    dataPath: 'l1Description',
    selectable: false,
    hidden: true,
    className: 'accountIdColumn'
  },
  [ReconDataSummaryColumnIds.l2Description]: {
    id: ReconDataSummaryColumnIds.l2Description,
    name: 'L2 Description',
    type: 'string',
    width: 1,
    filterable: false,
    sortable: false,
    searchable: false,
    facetable: false,
    hidden: true,
    selectable: false,
    className: 'accountIdColumn',
    dataPath: 'l2Description'
  },
  [ReconDataSummaryColumnIds.l3Description]: {
    id: ReconDataSummaryColumnIds.l3Description,
    name: 'L3 Description',
    type: 'string',
    width: 1,
    filterable: false,
    sortable: false,
    searchable: false,
    facetable: false,
    dataPath: 'l3Description',
    selectable: false,
    hidden: true,
    className: 'accountIdColumn'
  },
  [ReconDataSummaryColumnIds.l4Description]: {
    id: ReconDataSummaryColumnIds.l4Description,
    name: 'L4 Description',
    type: 'string',
    width: 1,
    filterable: false,
    sortable: false,
    searchable: false,
    facetable: false,
    dataPath: 'l4Description',
    selectable: false,
    hidden: true,
    className: 'accountIdColumn'
  },
  [ReconDataSummaryColumnIds.assetType]: {
    id: ReconDataSummaryColumnIds.assetType,
    name: 'Asset Type',
    type: 'string',
    width: 1,
    filterable: false,
    sortable: false,
    searchable: false,
    facetable: false,
    dataPath: 'assetType',
    selectable: false,
    hidden: true,
    className: 'accountIdColumn'
  },
  [ReconDataSummaryColumnIds.assetSubType]: {
    id: ReconDataSummaryColumnIds.assetSubType,
    name: 'Asset Sub Type',
    type: 'string',
    width: 1,
    filterable: false,
    sortable: false,
    searchable: false,
    facetable: false,
    hidden: true,
    selectable: false,
    className: 'accountIdColumn',
    dataPath: 'assetSubType'
  },
  [ReconDataSummaryColumnIds.platform]: {
    id: ReconDataSummaryColumnIds.platform,
    name: 'Platform',
    type: 'string',
    width: 130,
    filterable: true,
    sortable: true,
    searchable: true,
    facetable: true,
    dataPath: 'platform'
  }
}

export const ReconDataSummaryDefaultColumns: ColumnIdsEnum[] = [
  ColumnIdsEnum.id,
  ColumnIdsEnum.legalEntityName,
  ColumnIdsEnum.accountNo,
  ColumnIdsEnum.securityDesc,
  ColumnIdsEnum.cusip,
  ColumnIdsEnum.breakSummaryDetails,
  ColumnIdsEnum.advisorName,
  ColumnIdsEnum.householdName,
  ColumnIdsEnum.breakDesc,
  ColumnIdsEnum.breakdetailcount,
  ColumnIdsEnum.drawdown,
  ColumnIdsEnum.fundStructure,
  ColumnIdsEnum.assignedTo,
  ColumnIdsEnum.committedCapital,
  ColumnIdsEnum.capitalCalled,
  ColumnIdsEnum.remainingCapital,
  ColumnIdsEnum.distributionIncome,
  ColumnIdsEnum.netInvAmount,
  ColumnIdsEnum.totalIncomeReinv,
  ColumnIdsEnum.lastValuationValue,
  ColumnIdsEnum.valuationDate,
  ColumnIdsEnum.lasttransactionType,
  ColumnIdsEnum.lasttransactionDate,
  ColumnIdsEnum.lasttransactionAmount,
  ColumnIdsEnum.valuationReceivedDate,
  ColumnIdsEnum.reconDate,
  ColumnIdsEnum.reconAge,
  ColumnIdsEnum.adjMarketValue,
  ColumnIdsEnum.adjTotalValue,
  ColumnIdsEnum.price,
  ColumnIdsEnum.quantity,
  ColumnIdsEnum.adjTVPI,
  ColumnIdsEnum.annualizedIRR,
  ColumnIdsEnum.platform,
  ColumnIdsEnum.dataSource,
  ColumnIdsEnum.transType,
  ColumnIdsEnum.comments,
  ColumnIdsEnum.breakSummaryId,
  ColumnIdsEnum.breakSummaryStatus,
  ColumnIdsEnum.accountId,
  ColumnIdsEnum.l1Description,
  ColumnIdsEnum.l2Description,
  ColumnIdsEnum.l3Description,
  ColumnIdsEnum.l4Description,
  ColumnIdsEnum.assetType,
  ColumnIdsEnum.assetSubType
]
